import { map } from "lodash";

import toCamelCase from "./toCamelCase";

export default arr => {
  return map(arr, label => {
    return {
      id: toCamelCase(label),
      label
    };
  });
};
